module.exports = __webpack_public_path__ + "img/compare-arrow.970a29f6.svg";